import { api, ApiResponse } from "../lib/api.ts";
import { AdminAuthResponse, NotificationData, NotificationRequest, UpdateUserRequest, UserData, UserFullData } from "../entry/server/user.ts";

export const userService = {
    login: async (username: string, password: string): Promise<ApiResponse<AdminAuthResponse>> => {
        return await api.post<AdminAuthResponse>({
            url: "login",
            body: {
                username,
                password,
            },
        });
    },
    getUsers: async (page: number, limit: number, search?: string): Promise<ApiResponse<UserData[]>> => {
        return await api.get<UserData[]>({
            url: "users",
            queryParams: {
                page: page.toString(),
                limit: limit.toString(),
                search: search ?? "",
            },
        });
    },
    getUser: async (id: number): Promise<ApiResponse<UserFullData>> => {
        return await api.get<UserFullData>({
            url: `users/${id}`,
        });
    },
    updateUser: async (id: number, payload: UpdateUserRequest): Promise<ApiResponse<any>> => {
        return await api.put<any>({
            url: `users/${id}`,
            body: payload as unknown as Record<string, unknown>,
        });
    },
    deleteUser: async (id: number): Promise<ApiResponse<any>> => {
        return await api.delete<any>({
            url: `users/${id}`,
        });
    },
    deleteUserDevice: async (id: number, token: string): Promise<ApiResponse<any>> => {
        return await api.delete<any>({
            url: `users/${id}/devices/${encodeURIComponent(token)}`,
        });
    },
    getNotifications: async (page: number): Promise<ApiResponse<NotificationData[]>> => {
        return await api.get<NotificationData[]>({
            url: "notifications",
            queryParams: {
                page: page.toString(),
            },
        });
    },
    createNotification: async (payload: NotificationRequest): Promise<ApiResponse<any>> => {
        return await api.post<any>({
            url: "notifications",
            body: payload as unknown as Record<string, unknown>,
        });
    },
    deleteNotification: async (id: number): Promise<ApiResponse<any>> => {
        return await api.delete<any>({
            url: `notifications/${id}`,
        });
    },
};